// FY / calendar year labels for ESG Analytics (aligned with HomePage rules).

/** Inclusive bounds for the ESG Analytics reporting period year list (sidebar). */
export const ESG_ANALYTICS_REPORTING_PERIOD_START_YEAR = 2022;
export const ESG_ANALYTICS_REPORTING_PERIOD_END_YEAR = 2027;

const COMPARE_MONTH_LABEL_KEYS = {
  JANUARY: 'January.label',
  FEBRUARY: 'February.label',
  MARCH: 'March.label',
  APRIL: 'April.label',
  MAY: 'May.label',
  JUNE: 'June.label',
  JULY: 'July.label',
  AUGUST: 'August.label',
  SEPTEMBER: 'September.label',
  OCTOBER: 'October.label',
  NOVEMBER: 'November.label',
  DECEMBER: 'December.label',
};

const COMPARE_MONTH_NUMS = {
  JANUARY: 1,
  FEBRUARY: 2,
  MARCH: 3,
  APRIL: 4,
  MAY: 5,
  JUNE: 6,
  JULY: 7,
  AUGUST: 8,
  SEPTEMBER: 9,
  OCTOBER: 10,
  NOVEMBER: 11,
  DECEMBER: 12,
};

export function getCompareYearPeriodRangeLabel(t, yearNum, companyInfo = {}) {
  const y = Number(yearNum);
  const safeY = Number.isFinite(y) ? y : new Date().getFullYear();
  const dataFreqType = companyInfo?.frequencyType ?? companyInfo?.dataFrequencyType;
  if (dataFreqType === 'FY') {
    const startMonth = companyInfo?.financialYearStart || 'APRIL';
    const endMonth = companyInfo?.financialYearEnd || 'MARCH';
    const startLabel = COMPARE_MONTH_LABEL_KEYS[startMonth]
      ? t(COMPARE_MONTH_LABEL_KEYS[startMonth])
      : t('April.label');
    const endLabel = COMPARE_MONTH_LABEL_KEYS[endMonth]
      ? t(COMPARE_MONTH_LABEL_KEYS[endMonth])
      : t('March.label');
    const sm = COMPARE_MONTH_NUMS[startMonth] ?? 4;
    const em = COMPARE_MONTH_NUMS[endMonth] ?? 3;
    const startY = sm > em ? safeY - 1 : safeY;
    return `${startLabel} ${startY} ${t('HomePage.periodTo.label')} ${endLabel} ${safeY}`;
  }
  return `${t('January.label')} ${safeY} ${t('HomePage.periodTo.label')} ${t('December.label')} ${safeY}`;
}
